import sessionConstants from '../../constants/SessionConstants';
import UIConstants from '../../constants/UIConstants';
import sessionReader from '../../store/readHelpers/SessionReader';
import marketplacePropertiesService from '../MarketplacePropertiesService';

export const classNameTypes = {
    SCROLL: 'gap-multi-interaction-scroll',
    HORIZONTAL_SCROLL: 'gap-multi-interaction-horizontal-scroll',
    VISIBLE: 'gap-multi-interaction-visible',
};

const GapMatchInteractionServices = {
    getMultiInteractionClass(tokenPosition, zoomFactor, shouldAutoSizeTokens) {
        if (!marketplacePropertiesService.isEnableTwoInlineGapMatchAreas()) return '';
        const isPaperBased = sessionReader.isPrintStylePaperBased();
        const isReversedPosition = ['bottom', 'right', 'rightWithSplitPreview'].includes(tokenPosition);
        const isNotSmallTextSize = zoomFactor !== UIConstants.ZOOM_FACTOR.SMALL;
        const printStyle = sessionReader.getPrintParam('printStyle');
        if (printStyle === sessionConstants.PRINT_STYLE_STANDARD) return classNameTypes.VISIBLE;
        if (isReversedPosition && shouldAutoSizeTokens && !isPaperBased) return classNameTypes.HORIZONTAL_SCROLL;
        return isReversedPosition && isNotSmallTextSize ? classNameTypes.SCROLL : classNameTypes.VISIBLE;
    },
    getAutoSizeTokenStyles(gapWidth, shouldAutoSizeTokens) {
        const maximumWidth = 0.3 * window.innerWidth; // 30% of window size
        if (shouldAutoSizeTokens) {
            return {
                width: `${maximumWidth + 3}px`,
            };
        }
        return {
            maxWidth: `${maximumWidth + 3}px`,
            minWidth: `${gapWidth + 3}px`,
        };
    },
    getImageTokenDimensions(gapChoiceModel) {
        const imageHeight = gapChoiceModel?.dimensions?.height;
        const imageWidth = gapChoiceModel?.dimensions?.width;
        return { imageHeight, imageWidth };
    },
};

export default GapMatchInteractionServices;
